import { ADDPOINT_NOTIFICATION } from "../action/Action";

const initialState = {
    notification: false
}

const addPointNotificationReducer = (state = initialState, action) => {
    switch (action?.type) {
        case ADDPOINT_NOTIFICATION:
            return {
                ...state,
                notification: action?.payload
            };
        default:
            return state;
    }
}

export default addPointNotificationReducer;